import React from "react";
import photoSrc__2x from "assets/about-us/photo-owner-1.png";
import photoSrc from "assets/about-us/photo-owner-1__2x.png";
import photoSrc2 from "assets/about-us/photo-owner-2.png";
import photoSrc2__2x from "assets/about-us/photo-owner-2__2x.png";
import { useTranslation } from "locales";
import { LINK_LINKEDIN_OWNER_1, LINK_LINKEDIN_OWNER_2 } from "../../config";
import "./style.scss";

export default function BlockAboutOwners() {
  const { t } = useTranslation();

  return (
    <div className="block-about-owners mx-auto">
      <h1 className="h1 mb-10 text-center mx-auto mb-10">
        {t("Built by people who’ve lived it, and know how to help others get there.")}
      </h1>
      <div className="block-about-owners__owner-item mb-10">
        <div className="d-center">
          <a
            className="block-about-owners__link"
            href={LINK_LINKEDIN_OWNER_1}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img className="block-about-owners__photo" src={photoSrc} alt="Wasim Tahir" srcSet={photoSrc__2x + " 2x"} />
          </a>
        </div>
        <div className="caption-1 d-flex __align-center __order-top-desktop">
          {t(
            "Secure The Offer was founded by Wasim Tahir and Jonny Lewis, who know what it takes — and how tough it can be — to break into financial services."
          )}
          <br />
          <br />
          {t(
            "After years working inside top-tier institutions — from Jefferies and Credit Suisse to the Clermont Group — they saw too much potential go untapped simply because access depended on networks, not ability."
          )}
        </div>
      </div>
      <div className="block-about-owners__owner-item">
        <div className="d-center">
          <a
            className="block-about-owners__link"
            href={LINK_LINKEDIN_OWNER_2}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="block-about-owners__photo"
              src={photoSrc2}
              alt="Jonny Lewis"
              srcSet={photoSrc2__2x + " 2x"}
            />
          </a>
        </div>
        <div className="caption-1 d-flex __align-center">
          {t(
            "They built Secure The Offer to change that — turning insider experience into structured, practical coaching that helps students win offers and universities deliver measurable impact.\n"
          )}
          <br />
          <br />
          {t("block_about_owners__description_2")}
        </div>
      </div>
    </div>
  );
}
